import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import './Collapsible.css';

class Collapsible extends Component {
  	constructor(props) {
		super(props);
		this.state = { 
			collapse: false 
		};
  	}

  	toggle = () => {
		this.setState({ collapse: !this.state.collapse });
  	}

  	render() {
  		const answer = this.props.faq.answer;
		return (
	  		<div className="showtix-collapsible">
				<button className={this.state.collapse ? "showtix-collapsible__header is-open": "showtix-collapsible__header"} onClick={this.toggle}>{this.props.faq.question}</button>
				<Collapse className="showtix-collapsible__body" isOpen={this.state.collapse}>
					{ReactHtmlParser(answer)}
				</Collapse>
		  	</div>
		);
  	}
}

Collapsible.propTypes = {
    faq: PropTypes.shape({
        answer: PropTypes.string,
        question: PropTypes.string
    })
}

export default Collapsible;



// WEBPACK FOOTER //
// ./src/components/Common/Collapsible/Collapsible.js